angular.module('env.data.models.customerModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("CustomerModel",
            {
                extend: ['BaseModel'],
                url: "customers",
                fields: {
                    code: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    centreId: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    addressId: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    centreCode: {
                        type: RepresentationModelFieldTypes.STRING,
                        subResource: true,
                        get: function (rest, model) {
                            var centreId = model.$model.centreId;
                            if (centreId) {
                                return rest
                                    .map(rest.getDefinition("CentreModel"))
                                    .map(centreId).willReturn("CentreModel", centreId)
                                    .get()
                                    .then(function (restCentre) {
                                        return restCentre.$model.code;
                                    });
                            }
                            return null;
                        }
                    },
                    address: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.MODEL,
                        get: function (rest, model) {
                            if (model.$model.addressId) {
                                return rest
                                    .map(rest.getDefinition("AddressModel"))
                                    .map(model.$model.addressId)
                                    .willReturn("AddressModel", model.$model.addressId).get();
                            }
                            return null;
                        }
                    }
                }
            }
        );
    })

;
